module.exports = __webpack_public_path__ + "static/cosygiraffewhitestripe-493eac66408de28bfe3d54b30138522a.jpeg";